import * as PIXI from "pixi.js";
import { Coord } from "../../types/Interface";
import TimerRenderer from "./TimerRenderer";


interface TimerConfig {
  hours?: number,
  minutes?: number,
  seconds?: number
}


export default class Timer {
  private TimerRenderer!: TimerRenderer;
  private InitialSeconds!: number;
  private totalSeconds!: number;
  private timerInterval!: NodeJS.Timeout;

  constructor(con: PIXI.Container, coord: Coord, private options: TimerConfig | number = {}) {
    this.setTotalSeconds();
    this.TimerRenderer = new TimerRenderer(con, coord, this.totalSeconds);
    this.TimerRenderer.draw(this.totalSeconds);
  }
  private setTotalSeconds() {
    if(typeof this.options == "number") {
      this.totalSeconds = this.options;
    } else {
    const { hours, minutes, seconds } = this.options;
    this.totalSeconds = ((hours || 0) * 60 + (minutes || 0)) * 60 + (seconds || 0);
    }
    this.InitialSeconds = this.totalSeconds;
  }
  reset() {
    clearInterval(this.timerInterval);
    this.totalSeconds = this.InitialSeconds;
    this.TimerRenderer.draw(this.totalSeconds);
  }
  start() {
    this.TimerRenderer.draw(this.totalSeconds);
    this.timerInterval = setInterval(() => {
      this.totalSeconds--;
      this.TimerRenderer.draw(this.totalSeconds)
      this.totalSeconds == 0 ? clearInterval(this.timerInterval) : "";
    }, 1000)
  }
}